import { ReactNode, useCallback, useMemo, useRef } from 'react';
import { EntityHeaderContext } from './EntityHeaderContext';
import { EntityHeaderConfig } from './types';

export function EntityHeaderProvider({ children }: { children: ReactNode }) {
  const configRef = useRef<EntityHeaderConfig | null>(null);
  const subscribersRef = useRef<Set<() => void>>(new Set());

  const subscribe = useCallback((callback: () => void) => {
    subscribersRef.current.add(callback);
    return () => {
      subscribersRef.current.delete(callback);
    };
  }, []);

  const notify = useCallback(() => {
    subscribersRef.current.forEach(cb => cb());
  }, []);

  const value = useMemo(() => ({ configRef, subscribe, notify }), [subscribe, notify]);

  return <EntityHeaderContext.Provider value={value}>{children}</EntityHeaderContext.Provider>;
}
